import * as React from 'react';
import { Col, Progress, Row } from "antd";

interface SyncQueueProgressBarProps {
  current: number;
  max: number;
}

export default function SyncQueueProgressBar(props: SyncQueueProgressBarProps) {
  const { current, max } = props;
  const syncStatus = Math.round((current / max) * 100);
  return (
    <>
      <Row justify="center" style={{ marginBottom: 16 }}>
        <Col span={24} style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '16px' }}>Please wait while trees are being submitted</div>
        </Col>
      </Row>
      <Row justify="center">
        <Col span={24}>
          <Progress percent={syncStatus} showInfo={false} status="active" />
        </Col>
      </Row>
      <Row justify="center" style={{ marginTop: 12 }}>
        <Col span={24} style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '16px' }}>
            {current} / {max}
          </div>
        </Col>
      </Row>
    </>
  );
}
